import type { BffApiClient } from "@/app/api-client"
import { DEFAULT_SORT } from "@anaconda/core/nft/search/constants"
import type { InferRequestType } from "hono"

type QueryInput = InferRequestType<
  BffApiClient["api"]["nfts"]["search"]["$post"]
>["json"]

type Filters = QueryInput["filters"]

export const getNftCountQueryParams = (
  apiClient: BffApiClient,
  filters: Filters,
) => {
  const queryInput = {
    filters: {
      ...filters,
      blockchains: filters.blockchains,
    },
    pageSize: 1,
    sort: DEFAULT_SORT,
  }

  return {
    queryKey: ["nft", "count", queryInput],
    queryFn: async () => {
      const response = await apiClient.api.nfts.search.$post({
        json: queryInput,
      })

      if (!response.ok) {
        const errorData = await response.json()
        console.error(
          "[NFT Count Error]",
          response.status,
          errorData,
          "\nRequest params:",
          queryInput,
        )
        throw errorData
      }

      const { totalNftsCount } = await response.json()

      return totalNftsCount ?? 0
    },
  }
}

type QueryFn = ReturnType<typeof getNftCountQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
